<template>
    <div class="cash-withdrawal" style="padding-top: 1rem">
        <!--<navTitle title="绑定电子钱包"></navTitle>-->
        <!--        <navTitle :title=" $router.app._route.query.ti ? $router.app._route.query.ti : $t('message.my_pay.title')" path="/user"-->
        <!--        <navTitle :title="$t('message.my_pay.title')" path="/user" :ask="true" askName="Binance_te"></navTitle>-->
        <navTitle :title="$t('message.my_pay.title')"></navTitle>
        <div>
            <div class="row-wrap">
                <div class="row-T1"></div>
                <div class="row">
                    <div class="row-name">{{$t('message.my_pay.phone')}}</div>
                    <input class="input" :placeholder="$t('message.my_pay.phone_plac')" v-model="post.phone"/>
                </div>
                <div>
                    <div class="row">
                        <div class="row-name">{{$t('message.my_pay.bank_name')}}</div>
                        <select v-if="showSubmit" v-model="select_bank_name">
                            <option value="">{{$t('message.my_pay.select_bank_name')}}</option>
                            <option v-for="v in bankList" :value="v.org_name">{{v.org_name}}</option>
                        </select>
                        <input v-else class="input" type="text" v-model="post.bank_name"/>
                    </div>
                    <div class="row">
                        <div class="row-name">TàiKhoảnNgânHàng</div>
<!--                        <div class="row-name">Tài khoản ngân hàng</div>-->
<!--                        <div class="row-name">{{$t('message.my_pay.bank_account')}}</div>-->
                        <input v-if="showSubmit" class="input" type="text" :placeholder="$t('message.my_pay.bank_account')"
                               v-model="post.bank_account"/>
                        <input else class="input" type="text" v-model="bank_account_" readonly/>
                    </div>
                    <div class="row">
<!--                        <div class="row-name">{{$t('message.my_pay.beneficiary_name')}}</div>-->
                        <div class="row-name">TênTàiKhoản</div>
                        <input v-if="showSubmit" class="input" type="text" :placeholder="$t('message.my_pay.beneficiary_name')"
                               v-model="post.bank_account_name"/>
                        <input else class="input" type="text" v-model="bank_account_name_" readonly/>
                    </div>
                    <div class="row">
                        <div class="row-name">số ID</div>
                        <input v-if="showSubmit" class="input" type="text" placeholder="Điền số ID" v-model="post.personal_id"/>
                        <input else class="input" type="text" v-model="personal_id_" readonly/>
                    </div>
                    <div class="row">
                        <div class="row-name">Thư</div>
                        <input v-if="showSubmit" class="input" type="text" placeholder="điền email" v-model="post.email"/>
                        <input else class="input" type="text" v-model="email_" readonly/>
                    </div>
                </div>
            </div>
            <div class="tips">
                <b style="color: red">*</b>{{$t('message.my_pay.tip')}}
            </div>
            <div class="submit bg-color-blue" v-if="showSubmit" @click="submitted">{{$t('message.my_pay.bind')}}</div>
            <div v-if="is_set_pwd">
                <div class="submit bg-color-blue"  @click="editPwdDialog">Thay ₫ổi mật khẩu rút tiền</div>
                <div class="submit bg-color-blue"  @click="forgetPwdDialog">Quên mật khẩu rút tiền</div>
            </div>
            <div v-else>
                <div class="submit bg-color-blue" @click="setPwdDialog">₫ặt mật khẩu rút tiền</div>
            </div>
        </div>

        <div id="forPop" v-if="tx_pwd_bind" @click="bgClose"></div>
        <div v-if="tx_pwd_bind" class="set-pwd">
            <div v-if="!is_set_pwd">
                <div class="tx-pwd-title">₫ặt mật khẩu rút tiền</div>
                <div class="row">
                    <input type="password" class="input" placeholder="nhập mật khẩu" v-model="withdraw_pwd"/>
                </div>
                <div class="row">
                    <input type="password" class="input" placeholder="Xác nhận mật khẩu"
                           v-model="confirm_withdraw_pwd"/>
                </div>
                <div class="submit bg-color-blue" style="width: 80%;margin-left: 10%" @click="setWithdrawPassword">Chắc chắn rồi</div>
            </div>
            <div v-else-if="is_set_pwd && edit_set_pwd">
                <div class="tx-pwd-title">Thay ₫ổi mật khẩu rút tiền</div>
                <div class="row">
                    <input type="password" class="input" placeholder="Mật khẩu cũ" v-model="old_withdraw_pwd"/>
                </div>
                <div class="row">
                    <input type="password" class="input" placeholder="mật khẩu mới" v-model="new_withdraw_pwd"/>
                </div>
                <div class="row">
                    <input type="password" class="input" placeholder="Xác nhận mật khẩu"
                           v-model="confirm_withdraw_pwd"/>
                </div>
                <div class="submit bg-color-blue" style="width: 80%;margin-left: 10%" @click="editWithdrawPassword">Chắc chắn rồi</div>
            </div>
        </div>
        <div id="fpwd" v-if="forget_pwd" @click="fpwdClose"></div>
        <div v-if="forget_pwd" class="set-pwd">
            <div class="tx-pwd-title">Quên mật khẩu</div>
            <div class="row">
                <input type="number" class="input" placeholder="Số thẻ ngân hàng" v-model="forget_pwd_bank_card"/>
            </div>
            <div class="row">
                <input type="password" class="input" placeholder="mật khẩu mới" v-model="new_withdraw_pwd"/>
            </div>
            <div class="row">
                <input type="password" class="input" placeholder="Xác nhận mật khẩu"
                       v-model="confirm_withdraw_pwd"/>
            </div>
            <div class="set-tx-pwd-btn bg-color-blue" @click="resetPwd">₫ặt lại mật khẩu</div>
            <div class="set-tx-pwd-btn bg-qx" @click="fpwdClose">Khép kín</div>
        </div>

    </div>
</template>
<script>
    import {
        getUserInfo,
        get_vn_bank_list,
        get_payok_bank_list,
        recharge_bind_cash,
        getCashList,
        getWithdrawPasswordFlag,
        createWithdrawPassword,
        editWithdrawPassword,
        resetWithdrawPassword
    } from "../../api/user";
    import navTitle from "@components/navTitle";

    export default {
        name: "myPay",
        components: {navTitle},
        props: {},
        watch: {
            select_bank_name(n, o) {
                if(n===''){
                    this.post.bank_swift_code = '';
                    this.post.bank_name = '';
                    this.post.bank_info_id = '';
                    return;
                }
                let list = this.bankList;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].org_name === n) {
                        this.post.bank_swift_code = list[i].org_code;
                        this.post.bank_name = list[i].org_name;
                        this.post.payok_orgid = list[i].orgid;
                        this.post.bank_info_id = list[i].id;
                        return;
                    }
                }
            }
        },
        data: function () {
            return {
                my_cash: [], //已经绑定的电子钱包
                showSubmit: true, //默认显示新增绑定
                cashName: "PAYOK",
                select_bank_name: "",
                bank_account_: "",
                bank_account_name_: "",
                personal_id_: "",
                email_: "",
                bankList: [],
                post: {
                    cashName: "PAYOK",
                    phone: "",
                    payok_orgid: "",
                    bank_account: "",
                    bank_account_name: "",
                    bank_swift_code: "",
                    bank_name: "",
                    bank_info_id: "",
                    personal_id: "",
                    // first_name: "",
                    // last_name: "",
                    email: "",
                },

                forget_pwd: false,
                tx_pwd_bind: false,
                edit_set_pwd: false,
                forget_pwd_bank_card: '',
                is_set_pwd: '',
                withdraw_pwd: '',
                confirm_withdraw_pwd: '',
                old_withdraw_pwd: '',
                new_withdraw_pwd: '',
            };
        },
        mounted: function () {
            this.getUserInfo()
            this.getBankList()
            this.getBindCashList()
            this.getWithdrawPassword()
        },
        methods: {
            setStr(str, num) {
                return str.substring(0, num) + "****" + str.substr(str.length - num);
            },
            getUserInfo() {
                getUserInfo().then(res => {
                    // this.post.phone = res.data.phone.slice(2)
                    this.post.phone = res.data.phone
                })
            },
            getBankList() {
                get_payok_bank_list().then(res => {
                    this.bankList = res.data.bank_list
                    // console.log(res)
                })
            },
            getBindCashList() {
                getCashList().then(res => {
                    const list = res.data.data
                    // console.log(list)
                    if (list.length > 0) {
                        this.showSubmit = false
                        this.post.bank_info_id = list[0].bank_info_id
                        this.post.bank_name = list[0].bank_name
                        this.post.bank_account = list[0].bank_account
                        this.post.bank_account_name = list[0].bank_account_name
                        this.post.personal_id = list[0].personal_id
                        this.post.email = list[0].email
                        this.personal_id_ = this.setStr(list[0].personal_id,2)
                        this.email_ = list[0].email
                        this.bank_account_ = this.setStr(list[0].bank_account,2)
                        this.bank_account_name_ = this.setStr(list[0].bank_account_name,2)
                    }
                    // console.log(this.post)
                })
            },
            submitted() {
                if (!this.post.phone) {
                    this.$dialog.toast({mes: this.$t('message.my_pay.msg_phone')});
                    return;
                }
                if (this.post.bank_info_id===''||this.post.bank_swift_code===''||this.post.bank_name==='') {
                    this.$dialog.toast({mes: 'Vui lòng chọn một ngân hàng'});
                    return;
                }
                if (!this.post.bank_account.trim()) {
                    this.$dialog.toast({mes: this.$t('message.my_pay.msg_bank_account')});
                    return;
                }
                if (!this.post.bank_account_name.trim()) {
                    this.$dialog.toast({mes: this.$t('message.my_pay.msg_beneficiary_name')});
                    return;
                }
                // console.log(this.post)
                // return;
                let that = this
                this.$dialog.confirm({
                    mes: "<p>" + this.$t('message.my_pay.msg_confirm_msg4') + ": " + that.post.bank_account_name + "</p><p style='color: red'>" + this.$t('message.my_pay.msg_confirm_msg5') + ": " + that.post.bank_account + "</p>",
                    title: this.$t('message.my_pay.msg_confirm_title'),
                    opts: [
                        {
                            txt: this.$t('message.my_pay.msg_confirm_cancel'),
                            color: false,
                            callback: () => {
                                return that.$dialog.toast({mes: this.$t('message.my_pay.msg_confirm_cancelled')});
                            }
                        },
                        {
                            txt: this.$t('message.my_pay.msg_confirm'),
                            color: "#00C3F9",
                            callback: () => {
                                that.$dialog.loading.open('loading...')
                                recharge_bind_cash({
                                    type: that.cashName,
                                    phone: that.post.phone,
                                    bank_code: that.post.bank_swift_code,
                                    bank_name: that.post.bank_name,
                                    bank_account_name: that.post.bank_account_name,
                                    bank_account: that.post.bank_account,
                                    payok_orgid: that.post.payok_orgid,
                                    personal_id: that.post.personal_id,
                                    email: that.post.email,
                                    bank_info_id: that.post.bank_info_id,
                                }).then(res => {
                                    that.$dialog.loading.close();
                                    // console.log('绑定账户',res)
                                    that.$dialog.success(this.$t('message.my_pay.bind_success_msg') + " " + res.data.money) + "₫.";
                                    setTimeout(function () {
                                        location.reload();
                                    }, 3000)
                                }).catch(res => {
                                    that.$dialog.loading.close();
                                    that.$dialog.error(res.msg);
                                });
                            }
                        }
                    ]
                });
            },
            setWithdrawPassword(){
                let that = this
                let withdraw_pwd = this.withdraw_pwd
                if (withdraw_pwd === '')
                    return this.$dialog.error('Mật khẩu không ₫ược ₫ể trống')
                if (!/^\d{6}$/.test(withdraw_pwd.trim()))
                    return this.$dialog.error('Mật khẩu phải có 6 chữ số')
                let confirm_withdraw_pwd = this.confirm_withdraw_pwd
                if (confirm_withdraw_pwd !== withdraw_pwd)
                    return this.$dialog.error('Mật khẩu khác với Xác nhận mật khẩu')
                createWithdrawPassword({
                    'withdraw_pwd': withdraw_pwd,
                    'confirm_withdraw_pwd': confirm_withdraw_pwd
                }).then(res => {
                    that.$dialog.success(res.msg)
                    that.bgClose()
                    setTimeout(function () {
                        location.reload();
                    }, 500)
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            editWithdrawPassword() {
                this.tx_pwd_bind = true
                this.edit_set_pwd = true
                let old_withdraw_pwd = this.old_withdraw_pwd
                let new_withdraw_pwd = this.new_withdraw_pwd
                let confirm_withdraw_pwd = this.confirm_withdraw_pwd
                let that = this
                if (old_withdraw_pwd === '')
                    return this.$dialog.error('Mật khẩu cũ không ₫ược ₫ể trống')
                if (!/^\d{6}$/.test(new_withdraw_pwd.trim()))
                    return this.$dialog.error('Mật khẩu phải có 6 chữ số')
                if (confirm_withdraw_pwd !== new_withdraw_pwd)
                    return this.$dialog.error('Mật khẩu mới không giống với mật khẩu ₫ã xác nhận')
                editWithdrawPassword({
                    'old_withdraw_pwd': old_withdraw_pwd,
                    'new_withdraw_pwd': new_withdraw_pwd,
                    'confirm_withdraw_pwd': confirm_withdraw_pwd
                }).then(res => {
                    that.$dialog.success(res.msg)
                    that.bgClose()
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            getWithdrawPassword() {
                let that = this
                getWithdrawPasswordFlag().then(res => {
                    that.is_set_pwd = res.data.flag
                    // that.is_set_pwd = false
                }).catch(res => {
                    this.$dialog.error('yêu cầu ngoại lệ');
                })
            },
            bgClose: function () {
                this.withdraw_pwd = ''
                this.confirm_withdraw_pwd = ''
                this.old_withdraw_pwd = ''
                this.new_withdraw_pwd = ''
                this.tx_pwd_bind = false
                this.edit_set_pwd = false
            },
            setPwdDialog() {
                this.bgClose()
                this.tx_pwd_bind = true
            },
            editPwdDialog() {
                this.bgClose()
                this.tx_pwd_bind = true
                this.edit_set_pwd = true
                console.log(this.edit_set_pwd,this.is_set_pwd)
            },
            forgetPwdDialog() {
                this.bgClose()
                this.forget_pwd = true
            },
            resetPwd() {
                let new_withdraw_pwd = this.new_withdraw_pwd
                let confirm_withdraw_pwd = this.confirm_withdraw_pwd
                let forget_pwd_bank_card = this.forget_pwd_bank_card
                let that = this
                if (new_withdraw_pwd === '' || confirm_withdraw_pwd === '' || forget_pwd_bank_card === '')
                    return this.$dialog.error('₫ịnh dạng mật khẩu sai')
                if (!/^\d{6}$/.test(new_withdraw_pwd.trim()))
                    return this.$dialog.error('Mật khẩu phải có 6 chữ số')
                if (confirm_withdraw_pwd !== new_withdraw_pwd)
                    return this.$dialog.error('Mật khẩu mới không giống với mật khẩu ₫ã xác nhận')
                resetWithdrawPassword({
                    'new_withdraw_pwd': new_withdraw_pwd,
                    'confirm_withdraw_pwd': confirm_withdraw_pwd,
                    'bank_card_no': forget_pwd_bank_card
                }).then(res => {
                    that.$dialog.success(res.msg)
                    that.fpwdClose()
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            fpwdClose() {
                this.new_withdraw_pwd = ''
                this.confirm_withdraw_pwd = ''
                this.forget_pwd_bank_card = ''
                this.forget_pwd = false
            }
        }
    };
</script>
<style scoped>
    .cash-withdrawal {
        padding: 0.3rem;
        box-sizing: border-box;
        /*background: #FAFAFA;*/
    }

    .row-T1 {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
    }

    .row-info {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
        color: #999;
        margin-top: -10px;
    }

    .value-item {
        width: 100%;
        /*height: 5rem;*/
        background: #fff;
        padding: 0.27rem 0.27rem 0 0.27rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .value-item .flex {
        display: flex;
        width: 100%;
        height: 1.2rem;
        border-bottom: 1px solid #eee;
    }

    .value-item .T1 {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
    }

    .value-item .flex .I1 {
        width: 0.4rem;
        font-size: 0.85rem;
        line-height: 1.2rem;
        height: 1.2rem;
    }

    .value-item .flex input {
        width: 6rem;
        border: none;
        line-height: 1.2rem;
        height: 1.2rem;
        font-size: 0.65rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
    }

    .value-item .max {
        width: 100%;
        line-height: 1rem;
        height: 1rem;
    }

    .value-item .min {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    .href {
        color: #0c7cd8;
    }

    .row-wrap {
        /*margin-bottom: 0.3rem;*/
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 1rem;
        line-height: 1rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .row .select {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .submit {
        width: 100%;
        height: 0.92rem;
        background: rgba(0, 195, 249, 1);
        border-radius: 7px;
        color: #fff;
        line-height: 0.92rem;
        text-align: center;
        font-size: 0.35rem;
        margin-top: 1rem;
    }

    .tips {
        margin-top: 10px;
        color: #999;
    }

    .nickname-edit {
        border-radius: 5px;
        color: #fff;
        background-color: #00c3f9 !important;
        height: 30px;
        font-size: .25rem;
        line-height: .5rem;
        padding: 0px 4px;
        margin-top: 15px;
    }

    #fpwd, #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .set-pwd {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        height: auto;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .set-tx-pwd-btn {
        display: block;
        width: 2.5rem;
        height: 0.86rem;
        margin: 0.2rem;
        float: left;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .bg-qx {
        background-color: #f0f1f3;
    }

    .tx-pwd-title {
        font-weight: bold;
        text-align: center;
    }

    .forget-password {
        color: #ddd;
        text-align: right;
        padding-right: 0.2rem;
    }
</style>
